export default __webpack_public_path__ + "static/media/emacs.94291911.svg";